/// <reference types="./wizard.d.mts" />
import * as $when from "../../../../app_config/app_config/when.mjs";
import * as $bright from "../../../../bright/bright.mjs";
import * as $guards from "../../../../common/common/guards.mjs";
import * as $connector from "../../../../common/data/connector.mjs";
import * as $proposal_builder from "../../../../common/data/ephemeral/proposal_builder.mjs";
import * as $project from "../../../../common/data/project.mjs";
import * as $proposal from "../../../../common/data/proposal.mjs";
import * as $qualification_matrix from "../../../../common/data/qualification_matrix.mjs";
import * as $status from "../../../../common/data/status.mjs";
import * as $tag from "../../../../common/data/tag.mjs";
import * as $translate from "../../../../common/data/translate.mjs";
import * as $language from "../../../../common/data/translate/language.mjs";
import * as $user from "../../../../common/data/user.mjs";
import * as $timestamp_ from "../../../../common_common/gleam/time/timestamp/extra.mjs";
import * as $unsafe from "../../../../common_common/gleam/unsafe.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $combobox from "../../../../ds/ds/components/combobox.mjs";
import * as $dropdown from "../../../../ds/ds/components/dropdown.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $loader from "../../../../ds/ds/components/loader.mjs";
import * as $pp from "../../../../ds/ds/components/profile_picture.mjs";
import * as $stepper from "../../../../ds/ds/components/progress/stepper.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $cypress from "../../../../ds/ds/cypress.mjs";
import * as $events from "../../../../ds/ds/events.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $illustrations from "../../../../ds/ds/illustrations.mjs";
import * as $file from "../../../../ds/web/browser/file.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $mime_types from "../../../../mime_types/mime_types.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import * as $model from "../../../data/model.mjs";
import * as $state from "../../../data/model/state.mjs";
import * as $msg from "../../../data/msg.mjs";
import { select_document } from "../../../frontend/view/components/document_selector.mjs";
import { select_narrative } from "../../../frontend/view/components/narrative_selector.mjs";
import { select_columns } from "../../../frontend/view/components/spreadsheet_selector.mjs";
import * as $content_library from "../../../frontend/view/content_library.mjs";
import * as $dropdown_styles from "../../../frontend/view/styles/dropdowns.mjs";
import * as $s from "../../../frontend/view/styles/proposals.mjs";
import {
  Ok,
  Error,
  toList,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  isEqual,
} from "../../../gleam.mjs";
import * as $utils from "../../../utils.mjs";

const FILEPATH = "src/frontend/view/projects/wizard.gleam";

export class Props extends $CustomType {
  constructor(loading) {
    super();
    this.loading = loading;
  }
}

class Collaborator extends $CustomType {}

class Owner extends $CustomType {}

function wizard_stepper(model) {
  let state = $bright.state(model);
  let $ = state.proposal_builder.edit_status;
  if ($ instanceof $proposal_builder.NewProject) {
    return $stepper.steps(
      state.proposal_builder.step,
      toList([
        (() => {
          let _pipe = $stepper.step();
          let _pipe$1 = $stepper.description(_pipe, "Enter project details");
          return $stepper.hide(
            _pipe$1,
            (() => {
              let $1 = state.proposal_builder.edit_status;
              if ($1 instanceof $proposal_builder.NewProject) {
                return false;
              } else if ($1 instanceof $proposal_builder.NewProposal) {
                return true;
              } else if ($1 instanceof $proposal_builder.EditProject) {
                return true;
              } else {
                return true;
              }
            })(),
          );
        })(),
        (() => {
          let _pipe = $stepper.step();
          return $stepper.description(_pipe, "Enter proposal details");
        })(),
        (() => {
          let _pipe = $stepper.step();
          return $stepper.description(_pipe, "Upload file");
        })(),
        (() => {
          let _pipe = $stepper.step();
          return $stepper.description(_pipe, "Select questions");
        })(),
      ]),
    );
  } else if ($ instanceof $proposal_builder.NewProposal) {
    return $stepper.steps(
      state.proposal_builder.step,
      toList([
        (() => {
          let _pipe = $stepper.step();
          let _pipe$1 = $stepper.description(_pipe, "Enter project details");
          return $stepper.hide(
            _pipe$1,
            (() => {
              let $1 = state.proposal_builder.edit_status;
              if ($1 instanceof $proposal_builder.NewProject) {
                return false;
              } else if ($1 instanceof $proposal_builder.NewProposal) {
                return true;
              } else if ($1 instanceof $proposal_builder.EditProject) {
                return true;
              } else {
                return true;
              }
            })(),
          );
        })(),
        (() => {
          let _pipe = $stepper.step();
          return $stepper.description(_pipe, "Enter proposal details");
        })(),
        (() => {
          let _pipe = $stepper.step();
          return $stepper.description(_pipe, "Upload file");
        })(),
        (() => {
          let _pipe = $stepper.step();
          return $stepper.description(_pipe, "Select questions");
        })(),
      ]),
    );
  } else if ($ instanceof $proposal_builder.EditProject) {
    return $el.none();
  } else {
    return $el.none();
  }
}

function loader_screen(items) {
  return $l.column(
    toList([$l.flex("1"), $l.justify("center")]),
    toList([]),
    toList([$loader.loader(items)]),
  );
}

function page_loader() {
  return loader_screen(
    toList([
      "Uploading document",
      "Creating questions",
      "Preparing answers",
      "Polishing render",
      "Improving quality",
    ]),
  );
}

function file_loader() {
  return loader_screen(
    toList([
      "Reading document",
      "Analyzing content",
      "Absorbing data",
      "Polishing render",
      "Improving format",
    ]),
  );
}

function questions_selector(model) {
  let state = $bright.state(model);
  let $ = $proposal_builder.type_(state.proposal_builder);
  if ($ instanceof $proposal_builder.Questionnaire) {
    let selector = state.proposal_builder.proposal_spreadsheet;
    let cta_text = "Generate your responses";
    let _pipe = select_columns(selector, cta_text, false);
    return $el.map(
      _pipe,
      (var0) => {
        return new $msg.ProposalBuilderHandledSpreadsheetSelector(var0);
      },
    );
  } else if ($ instanceof $proposal_builder.Document) {
    let selector = state.proposal_builder.proposal_document;
    let _pipe = select_document(selector);
    return $el.map(
      _pipe,
      (var0) => { return new $msg.ProposalBuilderHandledDocumentSelector(var0); },
    );
  } else if ($ instanceof $proposal_builder.Narrative) {
    let selector = state.proposal_builder.proposal_pdf;
    let _pipe = select_narrative(selector);
    return $el.map(
      _pipe,
      (var0) => { return new $msg.ProposalBuilderHandledPdfSelector(var0); },
    );
  } else {
    return $el.none();
  }
}

function update_date(content) {
  let $ = $timestamp_.from_time_input(content);
  if ($ instanceof Ok) {
    let time = $[0];
    return new $msg.UserUpdatedProjectDeadline(time);
  } else {
    throw makeError(
      "panic",
      FILEPATH,
      "frontend/view/projects/wizard",
      147,
      "update_date",
      "Invalid date from browser",
      {}
    )
  }
}

function is_confirm_disabled(model) {
  let state = $bright.state(model);
  let $ = state.proposal_builder.project_id;
  let $1 = state.proposal_builder.edit_status;
  if ($1 instanceof $proposal_builder.NewProposal) {
    if ($ instanceof Some) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

function confirm_label(model) {
  let state = $bright.state(model);
  let $ = state.proposal_builder.edit_status;
  if ($ instanceof $proposal_builder.NewProject) {
    return "Confirm";
  } else if ($ instanceof $proposal_builder.NewProposal) {
    return "Confirm";
  } else if ($ instanceof $proposal_builder.EditProject) {
    return "Save";
  } else {
    return "Save";
  }
}

function go_back_button(model) {
  let state = $bright.state(model);
  let _block;
  let $ = state.proposal_builder.edit_status;
  if ($ instanceof $proposal_builder.NewProject) {
    _block = new $msg.UserWentBack(true);
  } else if ($ instanceof $proposal_builder.NewProposal) {
    _block = new $msg.UserWentBack(false);
  } else if ($ instanceof $proposal_builder.EditProject) {
    _block = new $msg.UserWentBack(true);
  } else {
    _block = new $msg.UserWentBack(true);
  }
  let on_click = _block;
  let _block$1;
  let _pipe = $e.on_click(on_click);
  let _pipe$1 = $e.prevent_default(_pipe);
  _block$1 = $e.stop_propagation(_pipe$1);
  let on_click$1 = _block$1;
  return $button.secondary(
    toList([on_click$1, $cypress.data("back-button")]),
    toList([$h.text("Go back")]),
  );
}

function add_project_id(model) {
  let state = $bright.state(model);
  let computed = $bright.computed(model);
  let $ = state.proposal_builder.edit_status;
  if ($ instanceof $proposal_builder.NewProject) {
    return $el.none();
  } else if ($ instanceof $proposal_builder.NewProposal) {
    let project_id = state.proposal_builder.project_id;
    let projects = $list.filter_map(
      state.projects,
      (project) => {
        let project$1 = project[1];
        let _block;
        let _pipe = state.user;
        _block = $option.map(_pipe, (user2) => { return user2.sub; });
        let user_id = _block;
        if (user_id instanceof $option.Some) {
          let user_id$1 = user_id[0];
          let $1 = $list.contains(
            $project.all_collaborators(project$1),
            user_id$1,
          );
          let $2 = project$1.status;
          if ($2 instanceof $status.InProgress) {
            if ($1) {
              return new Ok(project$1);
            } else {
              return new Error(undefined);
            }
          } else {
            return new Error(undefined);
          }
        } else {
          return new Error(undefined);
        }
      },
    );
    return $l.fragment(
      toList([
        $l.column(
          toList([$l.gap(6), $l.align("start"), $l.position("relative")]),
          toList([]),
          toList([
            $s.details_owner_label(toList([]), toList([$h.text("Project")])),
            $combobox.combobox(
              (var0) => { return new $msg.UserSelectedProjectId(var0); },
              toList([
                $combobox.selected(project_id),
                $combobox.placeholder("Project"),
                $combobox.icon($icons.folder()),
              ]),
              (() => {
                let _pipe = projects;
                return $list.map(
                  _pipe,
                  (project) => {
                    return $combobox.choice(project.name, project.id);
                  },
                );
              })(),
            ),
          ]),
        ),
        $l.column(
          toList([$l.gap(6), $l.align("start"), $l.position("relative")]),
          toList([]),
          toList([
            $s.details_owner_label(
              toList([]),
              toList([$h.text("Pre-fill using another proposal")]),
            ),
            $combobox.combobox(
              (var0) => { return new $msg.UserPrefilledProposal(var0); },
              toList([
                $combobox.disabled($option.is_none(project_id)),
                $combobox.selected(state.proposal_builder.proposal_pre_filled),
                $combobox.placeholder("None"),
                $combobox.icon($icons.proposal_file()),
                $combobox.input_class($s.details_collaborators_class()),
              ]),
              $list.flat_map(
                computed.projects.all,
                (project) => {
                  let project$1 = project[0];
                  let proposals = project[2];
                  let $1 = isEqual(new Some(project$1.id), project_id);
                  if ($1) {
                    return $list.map(
                      proposals,
                      (proposal) => {
                        return $combobox.choice(proposal.name, proposal.id);
                      },
                    );
                  } else {
                    return toList([]);
                  }
                },
              ),
            ),
          ]),
        ),
      ]),
    );
  } else if ($ instanceof $proposal_builder.EditProject) {
    return $el.none();
  } else {
    return $el.none();
  }
}

function add_users_button(type_, owners, collaborators, users, owner_id, msg) {
  let _block;
  if (type_ instanceof Collaborator) {
    _block = "collaborators";
  } else {
    _block = "owners";
  }
  let name = _block;
  return $combobox.combobox(
    msg,
    toList([
      $combobox.placeholder("Add " + name),
      $combobox.icon($icons.add_user()),
      $combobox.input_class($s.details_collaborators_class()),
    ]),
    listPrepend(
      $combobox.section("Select " + name),
      $list.filter_map(
        users,
        (user) => {
          let is_owner = user.id === owner_id;
          let is_contributor = $list.any(
            user.roles,
            (r) => {
              return (((r.name === $guards.roles.contributor) || (r.name === $guards.roles.proposal_manager)) || (r.name === $guards.roles.admin)) || (r.name === $guards.roles.content_curator);
            },
          );
          let _block$1;
          if (type_ instanceof Collaborator) {
            _block$1 = $list.contains(owners, user.id);
          } else {
            _block$1 = $list.contains(collaborators, user.id);
          }
          let is_already_selected = _block$1;
          let is_not_selectable = (!is_contributor || is_owner) || is_already_selected;
          return $bool.guard(
            is_not_selectable,
            new Error(undefined),
            () => {
              let id = user.id;
              let name$1 = user.name;
              let picture = user.picture;
              let initials = user.initials;
              let icon = $pp.from_user(picture, initials, new $pp.Medium());
              let _pipe = $combobox.choice(name$1, id);
              let _pipe$1 = $combobox.with_icon(_pipe, icon);
              return new Ok(_pipe$1);
            },
          );
        },
      ),
    ),
  );
}

function on_remove_collaborator(msg) {
  let _pipe = $e.on_click(msg);
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

function add_owners(owners, collaborators, users, owner_id) {
  let owners$1 = listPrepend(owner_id, owners);
  return $l.column(
    toList([$l.gap(6), $l.align("start"), $l.position("relative")]),
    toList([]),
    toList([
      $s.details_owner_label(toList([]), toList([$h.text("Owners")])),
      $l.row(
        toList([$l.gap(8), $l.wrap("wrap"), $l.align("center")]),
        toList([]),
        listPrepend(
          add_users_button(
            new Owner(),
            owners$1,
            collaborators,
            users,
            owner_id,
            (var0) => { return new $msg.UserAddedOwner(var0); },
          ),
          $list.map(
            owners$1,
            (user_id) => {
              let user = $list.find(users, (u) => { return u.id === user_id; });
              let picture = $result.map(user, (u) => { return u.picture; });
              let initials = $result.map(user, (u) => { return u.initials; });
              let name = $result.map(user, (u) => { return u.name; });
              return $s.details_owner_picture_deletion(
                toList([]),
                toList([
                  $l.row(
                    toList([$l.align("center"), $l.gap(6)]),
                    toList([]),
                    toList([
                      $pp.from_user(
                        $result.unwrap(picture, new $option.None()),
                        $result.unwrap(initials, "?"),
                        new $pp.Medium(),
                      ),
                      $h.text($result.unwrap(name, "Unknown name")),
                    ]),
                  ),
                  (() => {
                    let $ = user_id === owner_id;
                    if ($) {
                      return $el.none();
                    } else {
                      return $s.details_collaborators_icon_delete(
                        toList([
                          on_remove_collaborator(
                            new $msg.UserRemovedOwner(user_id),
                          ),
                        ]),
                        $icons.cross(),
                      );
                    }
                  })(),
                ]),
              );
            },
          ),
        ),
      ),
    ]),
  );
}

function add_collaborators(owners, collaborators, users, owner_id) {
  return $l.column(
    toList([$l.gap(6), $l.align("start"), $l.position("relative")]),
    toList([]),
    toList([
      $s.details_owner_label(toList([]), toList([$h.text("Collaborators")])),
      $l.row(
        toList([$l.gap(8), $l.wrap("wrap"), $l.align("center")]),
        toList([]),
        listPrepend(
          add_users_button(
            new Collaborator(),
            owners,
            collaborators,
            users,
            owner_id,
            (var0) => { return new $msg.UserAddedCollaborator(var0); },
          ),
          $list.map(
            collaborators,
            (user_id) => {
              let user = $list.find(users, (u) => { return u.id === user_id; });
              let picture = $result.map(user, (u) => { return u.picture; });
              let initials = $result.map(user, (u) => { return u.initials; });
              let name = $result.map(user, (u) => { return u.name; });
              return $s.details_owner_picture_deletion(
                toList([]),
                toList([
                  $l.row(
                    toList([$l.align("center"), $l.gap(6)]),
                    toList([]),
                    toList([
                      $pp.from_user(
                        $result.unwrap(picture, new $option.None()),
                        $result.unwrap(initials, "?"),
                        new $pp.Medium(),
                      ),
                      $h.text($result.unwrap(name, "Unknown name")),
                    ]),
                  ),
                  $s.details_collaborators_icon_delete(
                    toList([
                      on_remove_collaborator(
                        new $msg.UserRemovedCollaborator(user_id),
                      ),
                    ]),
                    $icons.cross(),
                  ),
                ]),
              );
            },
          ),
        ),
      ),
    ]),
  );
}

function enter_project_details(model) {
  let state = $bright.state(model);
  return $when.some(
    state.user,
    (owner) => {
      let project_name = state.proposal_builder.project_name;
      let _block;
      let _pipe = state.connectors.fetched;
      let _pipe$1 = $list.key_find(_pipe, new $connector.Salesforce());
      _block = $result.unwrap(_pipe$1, false);
      let is_salesforce_connected = _block;
      let _block$1;
      if (is_salesforce_connected) {
        _block$1 = (project_name === "") || ($option.unwrap(
          state.proposal_builder.salesforce_id,
          "",
        ) === "");
      } else {
        _block$1 = project_name === "";
      }
      let is_submit_disabled = _block$1;
      return $s.details_wrapper(
        toList([
          $e.on_submit(
            (_) => { return new $msg.UserSubmittedProjectDetails(); },
          ),
        ]),
        toList([
          $l.row(
            toList([$l.align("center"), $l.gap(8)]),
            toList([]),
            toList([
              $s.round_icon($icons.tiny($icons.folder())),
              $s.details_title(
                toList([]),
                toList([$h.text("Enter project details")]),
              ),
            ]),
          ),
          $l.column(
            toList([$l.gap(12)]),
            toList([]),
            toList([
              (() => {
                let $ = state.loading.projects;
                if ($) {
                  return $skeleton.full_width(45);
                } else {
                  return $input.input(
                    toList([
                      $input.label("Name"),
                      $input.value(project_name),
                      $input.on_input(
                        (var0) => {
                          return new $msg.UserUpdatedProjectName(var0);
                        },
                      ),
                      $input.data_test("name-input"),
                    ]),
                  );
                }
              })(),
              (() => {
                let $ = state.loading.projects;
                if ($) {
                  return $skeleton.full_width(45);
                } else {
                  return $input.input(
                    toList([
                      $input.label("Due Date"),
                      $input.type_("date"),
                      $input.on_input(update_date),
                      (() => {
                        let _pipe$2 = state.proposal_builder.project_deadline;
                        let _pipe$3 = $timestamp_.to_date_yyyymmdd(_pipe$2, "-");
                        return $input.value(_pipe$3);
                      })(),
                    ]),
                  );
                }
              })(),
              (() => {
                let $ = state.loading.projects;
                if ($) {
                  return $skeleton.full_width(45);
                } else {
                  return $input.input(
                    toList([
                      $input.label("Client"),
                      $input.value(state.proposal_builder.project_client),
                      $input.on_input(
                        (var0) => {
                          return new $msg.UserUpdatedProjectClient(var0);
                        },
                      ),
                      $input.data_test("client-input"),
                    ]),
                  );
                }
              })(),
              (() => {
                let $ = state.loading.projects;
                if (is_salesforce_connected) {
                  if ($) {
                    return $skeleton.full_width(45);
                  } else {
                    return $input.input(
                      toList([
                        $input.label("Salesforce Case ID"),
                        $input.value(
                          (() => {
                            let _pipe$2 = state.proposal_builder.salesforce_id;
                            return $option.unwrap(_pipe$2, "");
                          })(),
                        ),
                        $input.on_input(
                          (var0) => {
                            return new $msg.UserUpdatedProjectSalesforceId(var0);
                          },
                        ),
                        $input.data_test("name-input"),
                      ]),
                    );
                  }
                } else {
                  return $el.none();
                }
              })(),
              (() => {
                let $ = state.loading.projects;
                if ($) {
                  let _pipe$2 = $list.repeat(undefined, 1);
                  let _pipe$3 = $list.map(
                    _pipe$2,
                    (_) => { return $skeleton.skeleton(100, 35); },
                  );
                  return ((_capture) => {
                    return $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      _capture,
                    );
                  })(_pipe$3);
                } else {
                  let _pipe$2 = state.proposal_builder.project_owners;
                  let _pipe$3 = add_owners(
                    _pipe$2,
                    state.proposal_builder.project_collaborators,
                    state.organization.users,
                    owner.sub,
                  );
                  return $el.map(
                    _pipe$3,
                    (var0) => { return new $msg.UserEditedProjectUser(var0); },
                  );
                }
              })(),
              (() => {
                let $ = state.loading.projects;
                if ($) {
                  let _pipe$2 = $list.repeat(undefined, 3);
                  let _pipe$3 = $list.map(
                    _pipe$2,
                    (_) => { return $skeleton.skeleton(100, 35); },
                  );
                  return ((_capture) => {
                    return $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      _capture,
                    );
                  })(_pipe$3);
                } else {
                  let _pipe$2 = state.proposal_builder.project_collaborators;
                  let _pipe$3 = ((_capture) => {
                    return add_collaborators(
                      state.proposal_builder.project_owners,
                      _capture,
                      state.organization.users,
                      owner.sub,
                    );
                  })(_pipe$2);
                  return $el.map(
                    _pipe$3,
                    (var0) => { return new $msg.UserEditedProjectUser(var0); },
                  );
                }
              })(),
            ]),
          ),
          $l.row(
            toList([$l.justify("end")]),
            toList([]),
            toList([
              $s.submit_wrapper(
                toList([]),
                toList([
                  go_back_button(model),
                  $button.primary(
                    toList([
                      $a.type_("submit"),
                      $cypress.data("confirm-button"),
                      $a.disabled(is_submit_disabled),
                    ]),
                    toList([$h.text(confirm_label(model))]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function choice_class(bordered, bordered_cl, cl) {
  let _block;
  if (bordered) {
    _block = [bordered_cl(), $css.border_radius($length.px(8))];
  } else {
    _block = [cl(), $css.none()];
  }
  let $ = _block;
  let base = $[0];
  let border = $[1];
  return $css.class$(
    toList([$css.compose(base), $css.padding($length.px(10)), border]),
  );
}

function success_class(bordered) {
  return choice_class(
    bordered,
    $dropdown_styles.bordered_success,
    $dropdown_styles.success,
  );
}

function error_class(bordered) {
  return choice_class(
    bordered,
    $dropdown_styles.bordered_error,
    $dropdown_styles.error,
  );
}

function qualification_matrix_actions(disabled) {
  let confirm = $e.on_click(new $msg.UserConfirmedProposalQualificationMatrix());
  return $l.row(
    toList([$l.justify("space-between"), $l.gap(16)]),
    toList([]),
    toList([
      $button.secondary(
        toList([$a.disabled(true)]),
        toList([$h.text("Customize your matrix")]),
      ),
      $l.row(
        toList([$l.gap(16)]),
        toList([]),
        toList([
          $button.primary(
            toList([confirm, $a.disabled(disabled)]),
            toList([$h.text("Confirm")]),
          ),
        ]),
      ),
    ]),
  );
}

function total_questions(wrapper, wording, amount, total) {
  let amount$1 = $int.to_string($float.round(amount));
  let total$1 = $int.to_string($float.round(total));
  return wrapper(
    toList([]),
    toList([
      $h.text(((((amount$1 + "/") + total$1) + " ") + wording) + " flags"),
    ]),
  );
}

function qualification_matrix_progress_bar(success, failure, total) {
  return $l.row(
    toList([$l.gap(16), $l.align("center")]),
    toList([]),
    toList([
      total_questions($s.success_text, "Green", success, total),
      $s.progress_bar(success, failure, total),
      total_questions($s.error_text, "Red", failure, total),
    ]),
  );
}

function qualification_matrix_decision() {
  let use_qualification_matrix = "Would you like to use a Go/No-Go Matrix?";
  return $s.layout_wrapper(
    toList([]),
    toList([
      $illustrations.lightbulb_flash(),
      $l.column(
        toList([$l.gap(16)]),
        toList([]),
        toList([
          $l.column(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $s.details_title(
                toList([]),
                toList([$h.text(use_qualification_matrix)]),
              ),
              $s.details_subtitle(
                toList([]),
                toList([
                  $h.text("This will help you determine whether to respond to"),
                  $h.text(" the request and prioritize it effectively."),
                ]),
              ),
            ]),
          ),
          $l.row(
            toList([$l.gap(16)]),
            toList([]),
            toList([
              $button.primary(
                toList([
                  $e.on_click(new $msg.UserUsedProposalQualificationMatrix()),
                ]),
                toList([$h.text("Yes")]),
              ),
              $button.secondary(
                toList([
                  $e.on_click(new $msg.UserSkippedProposalQualificationMatrix()),
                ]),
                toList([
                  $h.text("Maybe next time"),
                  $icons.small($icons.right_arrow()),
                ]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

export function qualification_matrix(builder) {
  let $ = builder.proposal_qualification_matrix;
  if ($ instanceof Some) {
    let qualification_matrix$1 = $[0];
    let $1 = $proposal.count_qualification_matrix_answers(
      qualification_matrix$1,
    );
    let success = $1[0];
    let failure = $1[1];
    let total = $1[2];
    return $l.fragment(
      toList([
        $table.table(
          toList([]),
          toList([
            $table.headers(
              toList([
                $table.header("Qualification Item"),
                $table.header("Clarifying question"),
                (() => {
                  let _pipe = $table.header("Answer");
                  return $table.fit(_pipe);
                })(),
              ]),
            ),
            $table.body(
              $list.map(
                qualification_matrix$1,
                (_use0) => {
                  let item = _use0[0];
                  let answer = _use0[1];
                  return $table.row(
                    toList([
                      $table.cell($h.text(item.title)),
                      $table.cell($h.text(item.content)),
                      $table.cell(
                        $dropdown.dropdown(
                          (_capture) => {
                            return new $msg.UserSelectedProposalQualificationMatrix(
                              item.id,
                              _capture,
                            );
                          },
                          toList([
                            $dropdown.selected(new Some(answer)),
                            $dropdown.show_arrow(),
                            $dropdown.placeholder("Choose answer"),
                            $dropdown.panel_class(
                              $css.class$(
                                toList([
                                  $css.gap($length.px(10)),
                                  $css.padding($length.px(10)),
                                ]),
                              ),
                            ),
                            $dropdown.input_class(
                              (() => {
                                if (answer instanceof $qualification_matrix.NotSelected) {
                                  return $css.class$(toList([]));
                                } else if (answer instanceof $qualification_matrix.Yes) {
                                  return success_class(true);
                                } else {
                                  return error_class(true);
                                }
                              })(),
                            ),
                          ]),
                          toList([
                            (() => {
                              let _pipe = $dropdown.choice(
                                "Yes",
                                new $qualification_matrix.Yes(),
                              );
                              return $dropdown.with_class(
                                _pipe,
                                success_class(false),
                              );
                            })(),
                            (() => {
                              let _pipe = $dropdown.choice(
                                "No",
                                new $qualification_matrix.No(),
                              );
                              return $dropdown.with_class(
                                _pipe,
                                error_class(false),
                              );
                            })(),
                          ]),
                        ),
                      ),
                    ]),
                  );
                },
              ),
            ),
          ]),
        ),
        qualification_matrix_progress_bar(success, failure, total),
        qualification_matrix_actions((success + failure) === 0.0),
      ]),
    );
  } else {
    return qualification_matrix_decision();
  }
}

function edit_proposal_name(model) {
  let state = $bright.state(model);
  let $ = state.proposal_builder.edit_status;
  if ($ instanceof $proposal_builder.NewProject) {
    return $el.none();
  } else if ($ instanceof $proposal_builder.NewProposal) {
    return $el.none();
  } else if ($ instanceof $proposal_builder.EditProject) {
    return $el.none();
  } else {
    let $1 = state.loading.proposals;
    if ($1) {
      return $skeleton.full_width(45);
    } else {
      return $input.input(
        toList([
          $input.label("Name"),
          $input.value(state.proposal_builder.proposal_name),
          $input.on_input(
            (var0) => { return new $msg.UserUpdatedProposalName(var0); },
          ),
        ]),
      );
    }
  }
}

function add_context(model) {
  let state = $bright.state(model);
  let value = state.proposal_builder.proposal_additional_context;
  return $l.column(
    toList([$l.gap(6)]),
    toList([]),
    toList([
      $s.details_owner_label(
        toList([]),
        toList([$h.text("Additional proposal context")]),
      ),
      $s.context_input(
        toList([]),
        toList([
          $h.text(
            "You can provide any additional information that might be useful",
          ),
          $h.text(" for helping the AI provide better answers."),
          (() => {
            let $ = state.loading.proposals;
            if ($) {
              return $skeleton.full_width(140);
            } else {
              return $input.input(
                toList([
                  $input.value(value),
                  $input.multiline(),
                  $input.on_input(
                    (var0) => { return new $msg.UserUpdatedContext(var0); },
                  ),
                ]),
              );
            }
          })(),
        ]),
      ),
    ]),
  );
}

function on_remove_language(language) {
  let _pipe = $e.on_click(new $msg.UserRemovedProposalLanguage(language));
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

function languages_pills(model) {
  let state = $bright.state(model);
  return $list.map(
    (() => {
      let $ = state.loading.proposals;
      if ($) {
        return $list.take($language.all, 2);
      } else {
        return state.proposal_builder.proposal_languages;
      }
    })(),
    (language) => {
      let $ = state.loading.proposals;
      if ($) {
        return $skeleton.skeleton(100, 35);
      } else {
        return $s.details_owner_picture_deletion(
          toList([]),
          toList([
            $h.text($translate.display_language(language, new $option.None())),
            $s.details_collaborators_icon_delete(
              toList([on_remove_language(language)]),
              $icons.cross(),
            ),
          ]),
        );
      }
    },
  );
}

function add_languages(model) {
  let state = $bright.state(model);
  let is_hidden = $state.is_translations_hidden(state);
  return $bool.lazy_guard(
    is_hidden,
    $el.none,
    () => {
      return $l.column(
        toList([$l.gap(6), $l.align("start"), $l.position("relative")]),
        toList([]),
        toList([
          $s.details_owner_label(toList([]), toList([$h.text("Languages")])),
          $l.row(
            toList([$l.gap(8), $l.wrap("wrap"), $l.align("center")]),
            toList([]),
            listPrepend(
              $dropdown.dropdown(
                (var0) => { return new $msg.UserAddedProposalLanguage(var0); },
                toList([
                  $dropdown.placeholder("Add language"),
                  $dropdown.icon($icons.translate()),
                  $dropdown.input_class($s.details_collaborators_class()),
                ]),
                listPrepend(
                  $dropdown.section("Select language"),
                  $list.map(
                    $language.all,
                    (language) => {
                      let title = $translate.display_language(
                        language,
                        new $option.None(),
                      );
                      let _pipe = $dropdown.choice(title, language);
                      return $dropdown.as_selected(
                        _pipe,
                        $list.contains(
                          state.proposal_builder.proposal_languages,
                          language,
                        ),
                      );
                    },
                  ),
                ),
              ),
              languages_pills(model),
            ),
          ),
        ]),
      );
    },
  );
}

function on_remove_tag(tag) {
  let _pipe = $e.on_click(new $msg.UserRemovedProposalTag(tag));
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

function tags_pills(model) {
  let state = $bright.state(model);
  return $list.map(
    (() => {
      let $ = state.loading.proposals;
      if ($) {
        return $list.repeat(new $tag.Tag("", "", ""), 2);
      } else {
        return state.proposal_builder.proposal_tags;
      }
    })(),
    (tag) => {
      let $ = state.loading.proposals;
      if ($) {
        return $skeleton.skeleton(100, 35);
      } else {
        return $s.details_owner_picture_deletion(
          toList([]),
          toList([
            $h.text(tag.name),
            $s.details_collaborators_icon_delete(
              toList([on_remove_tag(tag)]),
              $icons.cross(),
            ),
          ]),
        );
      }
    },
  );
}

function add_tags(model) {
  let state = $bright.state(model);
  let tags = state.organization.tags;
  return $l.column(
    toList([$l.gap(6), $l.align("start"), $l.position("relative")]),
    toList([]),
    toList([
      $s.details_owner_label(toList([]), toList([$h.text("Tags")])),
      $l.row(
        toList([$l.gap(8), $l.wrap("wrap"), $l.align("center")]),
        toList([]),
        listPrepend(
          $dropdown.dropdown(
            (var0) => { return new $msg.UserAddedProposalTag(var0); },
            toList([
              $dropdown.placeholder("Add tag"),
              $dropdown.icon($icons.price_tag()),
              $dropdown.input_class($s.details_collaborators_class()),
            ]),
            listPrepend(
              $dropdown.section("Select tag"),
              $list.map(
                tags,
                (tag) => {
                  let _pipe = $dropdown.choice(tag.name, tag);
                  return $dropdown.as_selected(
                    _pipe,
                    $list.contains(state.proposal_builder.proposal_tags, tag),
                  );
                },
              ),
            ),
          ),
          tags_pills(model),
        ),
      ),
    ]),
  );
}

function on_remove_style_guideline() {
  let _pipe = $e.on_click(new $msg.UserRemovedProposalStyleGuideline());
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

function add_style_guideline(model) {
  let state = $bright.state(model);
  let style_guidelines = state.organization.style_guidelines;
  return $bool.lazy_guard(
    $list.is_empty(style_guidelines),
    $el.none,
    () => {
      return $l.column(
        toList([$l.gap(6), $l.align("start"), $l.position("relative")]),
        toList([]),
        toList([
          $s.details_owner_label(
            toList([]),
            toList([$h.text("Style guideline")]),
          ),
          $l.row(
            toList([$l.gap(8), $l.wrap("wrap"), $l.align("center")]),
            toList([]),
            listPrepend(
              $dropdown.dropdown(
                (var0) => {
                  return new $msg.UserAddedProposalStyleGuideline(var0);
                },
                toList([
                  $dropdown.placeholder("Add style guideline"),
                  $dropdown.icon($icons.file_edit()),
                  $dropdown.input_class($s.details_collaborators_class()),
                  $dropdown.disabled(
                    $option.is_some(
                      state.proposal_builder.proposal_style_guidelines,
                    ),
                  ),
                ]),
                listPrepend(
                  $dropdown.section("Select style guideline"),
                  $list.map(
                    style_guidelines,
                    (s) => { return $dropdown.choice(s.name, s); },
                  ),
                ),
              ),
              (() => {
                let $ = state.proposal_builder.proposal_style_guidelines;
                if ($ instanceof Some) {
                  let s = $[0];
                  return toList([
                    $s.details_owner_picture_deletion(
                      toList([]),
                      toList([
                        $h.text(s.name),
                        $s.details_collaborators_icon_delete(
                          toList([on_remove_style_guideline()]),
                          $icons.cross(),
                        ),
                      ]),
                    ),
                  ]);
                } else {
                  return toList([]);
                }
              })(),
            ),
          ),
        ]),
      );
    },
  );
}

function enter_proposal_details(model) {
  let state = $bright.state(model);
  return $s.details_wrapper(
    toList([
      $e.on_submit((_) => { return new $msg.UserSubmittedProposalDetails(); }),
    ]),
    toList([
      $l.row(
        toList([$l.align("center"), $l.gap(8)]),
        toList([]),
        toList([
          $s.round_icon($icons.tiny($icons.proposal_file())),
          $s.details_title(
            toList([]),
            toList([
              $h.text(
                (() => {
                  let $ = state.proposal_builder.edit_status;
                  if ($ instanceof $proposal_builder.NewProject) {
                    return "Enter proposal details";
                  } else if ($ instanceof $proposal_builder.NewProposal) {
                    return "Enter proposal details";
                  } else if ($ instanceof $proposal_builder.EditProject) {
                    return "Enter proposal details";
                  } else {
                    return "Edit proposal details";
                  }
                })(),
              ),
            ]),
          ),
        ]),
      ),
      $l.column(
        toList([$l.gap(12)]),
        toList([]),
        toList([
          add_project_id(model),
          edit_proposal_name(model),
          add_languages(model),
          add_tags(model),
          add_style_guideline(model),
          add_context(model),
        ]),
      ),
      $l.row(
        toList([$l.justify("end")]),
        toList([]),
        toList([
          $s.submit_wrapper(
            toList([]),
            toList([
              go_back_button(model),
              $button.primary(
                toList([
                  $a.type_("submit"),
                  $cypress.data("confirm-button"),
                  $a.disabled(is_confirm_disabled(model)),
                ]),
                toList([$h.text(confirm_label(model))]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function files_suported_text(model) {
  let state = $bright.state(model);
  let $ = $state.is_word_hidden(state);
  if ($) {
    let _pipe = toList([
      "We support excel questionnaires and word documents.",
      "To be able to upload word documents",
      "request Steerlab team to enable it",
    ]);
    return $string.join(_pipe, " ");
  } else {
    return "We support excel questionnaires and word documents";
  }
}

function read_file(files) {
  return $result.try$(
    $list.first(files),
    (file) => {
      return $result.try$(
        $mime_types.from_string($file.mime(file)),
        (mime) => {
          let mimes = toList([
            new $mime_types.Docx(),
            new $mime_types.Xlsx(),
            new $mime_types.Pdf(),
          ]);
          let is_valid = $list.contains(mimes, mime);
          return $bool.guard(
            !is_valid,
            new Error(undefined),
            () => { return new Ok([file, mime]); },
          );
        },
      );
    },
  );
}

function on_upload_files() {
  return $events.on_files_change(
    (files) => {
      let $ = read_file(files);
      if ($ instanceof Ok) {
        let file = $[0][0];
        let mime = $[0][1];
        if (mime instanceof $mime_types.Docx) {
          let _pipe = file;
          let _pipe$1 = new $msg.UserSelectedDocx(_pipe);
          let _pipe$2 = new $msg.ProposalBuilderHandledDocumentSelector(_pipe$1);
          return $decode.success(_pipe$2);
        } else if (mime instanceof $mime_types.Xlsx) {
          let _pipe = file;
          let _pipe$1 = new $msg.UserSelectedXlsx(_pipe);
          let _pipe$2 = new $msg.ProposalBuilderHandledSpreadsheetSelector(
            _pipe$1,
          );
          return $decode.success(_pipe$2);
        } else if (mime instanceof $mime_types.Pdf) {
          let _pipe = file;
          let _pipe$1 = new $msg.UserSelectedPdf(_pipe);
          let _pipe$2 = new $msg.ProposalBuilderHandledPdfSelector(_pipe$1);
          return $decode.success(_pipe$2);
        } else {
          throw makeError(
            "panic",
            FILEPATH,
            "frontend/view/projects/wizard",
            946,
            "on_upload_files",
            "Unhandled file mime",
            {}
          )
        }
      } else {
        return $decode.failure($unsafe.coerce(""), "");
      }
    },
  );
}

function upload_file(model) {
  let state = $bright.state(model);
  return $bool.lazy_guard(
    state.proposal_builder.proposal_spreadsheet.processing,
    $content_library.spreadsheet_loader_screen,
    () => {
      let is_loading = state.proposal_builder.proposal_document.loading || state.proposal_builder.proposal_pdf.loading;
      return $bool.lazy_guard(
        is_loading,
        file_loader,
        () => {
          return $s.layout_wrapper(
            toList([]),
            toList([
              $s.drag_and_drop_zone(
                toList([]),
                toList([
                  $s.icon_wrapper(toList([]), toList([$icons.upload()])),
                  $l.column(
                    toList([$l.gap(16), $l.align("center")]),
                    toList([]),
                    toList([
                      $s.drop_title(
                        toList([]),
                        toList([$h.text("Select your file to upload")]),
                      ),
                      $s.drop_subtitle(
                        toList([]),
                        toList([$h.text(files_suported_text(model))]),
                      ),
                    ]),
                  ),
                  $h.label(
                    toList([]),
                    toList([
                      $s.file_input(
                        toList([]),
                        toList([$h.text("Select file")]),
                      ),
                      $h.input(
                        toList([
                          $cypress.data("select-file-button"),
                          $a.type_("file"),
                          $a.style("display", "none"),
                          on_upload_files(),
                          $utils.restrict_proposal(
                            $state.is_word_hidden(state),
                            $state.is_narrative_hidden(state),
                          ),
                        ]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function view_body(model, props) {
  return $bool.lazy_guard(
    props.loading,
    page_loader,
    () => {
      let state = $bright.state(model);
      let $ = state.proposal_builder.step;
      if ($ === 1) {
        return enter_project_details(model);
      } else if ($ === 2) {
        return enter_proposal_details(model);
      } else if ($ === 3) {
        return upload_file(model);
      } else if ($ === 4) {
        return questions_selector(model);
      } else {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/view/projects/wizard",
          96,
          "view_body",
          "Unexpected step",
          {}
        )
      }
    },
  );
}

export function view(model, props) {
  return $l.fragment(toList([wizard_stepper(model), view_body(model, props)]));
}
